export default {
  'notAuthorized.title': 'Not authorized',
  'notAuthorized.description':
    'Oops, you are not authorised to see this page :(',
  'notAuthorized.button': 'Back to login',
};
